<template>
	<div class="w-100 bg-white">
		<span class="position-relative" style="top:-50px" id="room-type"></span>
		<!-- <Header></Header> -->
		<div class="hide-768px">
			<HomeNavbarDesktop @shareClick="shareClick" @callClick="callClick" />
		</div>
		<div class="show-768px">
			<HomeNavbarMobile @shareClick="shareClick" @callClick="callClick" />
		</div>
		<div v-if="is_load" class="w-100 py-4 mt-5 text-center">
      <loader />
    </div>
		<div class="px-10 pt-5 bg-white" v-else>
			<div class="d-inline-block mb-4 cursor-pointer mt-5 pt-3">
				<router-link :to="'/'+getMerchant.code+'/'">
					<div class="">
						<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path fill-rule="evenodd" clip-rule="evenodd" d="M16.9107 10.6857C17.2435 10.6399 17.5 10.3504 17.5 10.0001C17.5 9.61795 17.1947 9.30816 16.8182 9.30816L4.83339 9.30816L9.16276 4.93222L9.22893 4.85475C9.42753 4.58429 9.40631 4.19984 9.16475 3.95368C8.89904 3.6829 8.46733 3.68199 8.20052 3.95165L2.71023 9.50036C2.67753 9.53215 2.64794 9.56722 2.62198 9.60504C2.43614 9.87525 2.46234 10.2501 2.70056 10.4908L8.20056 16.0484L8.27717 16.1152C8.54452 16.3156 8.92325 16.2925 9.16479 16.0463C9.43048 15.7755 9.42955 15.3374 9.16271 15.0677L4.83231 10.692L16.8182 10.692L16.9107 10.6857Z" fill="#222222"/>
						</svg>
						<p class="mb-0 d-inline-block body-1-2 ml-1 top-2 position-relative font-medium text-18">{{$t('general.back')}}</p>
					</div>
				</router-link>
			</div>
		 	<p class="heading-5 mb-1">{{$t('hotel.room-type.room-type')}}</p>
		 	<p class="body-2-2-1 border-bottom pb-4 sub-title text-15 mb-5">{{$t('hotel.room-type.room-type-sub')}}</p>
			<div class="pb-5 mb-5 border-bottom room-type-border-m" v-for="data in room_type">
			 	<div class="row">
			 		<div class="col-12 col-lg-4">
			 			<div class="img-room-type">
			 				<flickity ref="flickity" class="" :options="freeScrollSlider" v-if="data.image.length != 0">
					      <div class="carousel-cell w-100" v-for="image in data.image">
					      	<router-link :to="'/'+getMerchant.code+'/room-type/'+data.id+''">
					        	<div class="img-hover-zoom radius-6">
				    					<img :src="image.image_url" class="radius-6 img-fit slider-hover" style="height:270px;">
					        	</div>
					        </router-link>
					      </div>
					    </flickity>
		    			<img :src="image_undefine" v-else class="img-fit slider-hover" :alt="getMerchant.name" style="height:270px;">
			 			</div>
			 		</div>
			 		<div class="col-12 col-lg-8">
			 			<div class="room-type px-3 py-2 room-type-desc-m">
							<router-link :to="'/'+getMerchant.code+'/room-type/'+data.id+''">
								<p class="mb-2 body-1-2 font-bold text-26 text-20-m cursor-pointer d-inline-block hover-link" @click="detailRoomType(data.id)">{{data.name}}</p>
							</router-link>
				 			<div class="row">
				 				<div class="col-12 col-lg-8">
				 					<p class="mb-0 body-2-2 text-16 text-14-m">{{$t('hotel.starting-from')}}:</p>
									<p class="mb-3 body-2-2-3 text-20 text-orange text-17-m">{{formatCurrency(data.best_price.final_price)}}</p>
						 			<div class="">
				  					<div class="d-inline-block mr-2 mb-3" v-show="data.room_size !== '0'">
                      <p class="mb-0 body-3 lh-1 mb-1">{{$t('hotel.unit-type.'+data.type+'.size')}}</p>
				    					<i class="simple-icon-size-fullscreen text-green text-15 d-inline-block align-middle mr-1 font-weight-bold"></i>
				              <p class="mb-0 body-2-1 d-inline-block align-middle text-15">{{data.room_size}} m²</p>
				    				</div>
				    				<div class="d-inline-block mr-2 mb-3">
                      <p class="mb-0 body-3 lh-1 mb-1">{{$t('hotel.room-type.total-bedroom')}}</p>
				    					<i class="simple-icon-home text-green text-15 d-inline-block align-middle mr-1 font-weight-bold"></i>
											<p class="mb-0 body-2-1 d-inline-block align-middle text-15">{{data.total_rooms}} {{$t('hotel.room-type.bedrooms')}}</p>
				    				</div>
				    				<div class="d-inline-block mr-2 mb-3">
                      <p class="mb-0 body-3 lh-1 mb-1">{{$t('hotel.room-type.bed-type')}}</p>
				    					<i class="simple-icon-grid text-green text-15 d-inline-block align-middle mr-1 font-weight-bold"></i>
				              <p class="mb-0 body-2-1 d-inline-block align-middle text-15">
				                <template v-for="(bed, index) in data.bed">
				                	{{bed.qty}} {{bed.name}}<span v-if="index + 1 < data.bed.length">,</span>
				                </template>
				              </p>
				    				</div>
				  				</div>
						 			<p class="mb-0 body-2-2-1 mb-0 lh-25 text-16 pr-3 text-truncate-2 p-0-m">{{data.description}}</p>
									<router-link :to="'/'+getMerchant.code+'/room-type/'+data.id">
							 			<p class="mb-3 body-3-1 text-14 cursor-pointer text-green border-bottom-green d-inline-block mt-1">{{$t('hotel.concierge.fitur.read-more')}}.</p>
							 		</router-link>
				 				</div>
				 				<div class="col-12 col-lg-4">
				 					<div class="hide-576px">
							 			<p class="mb-3 text-16 font-semibold text-semi-dark">{{$t('hotel.room-type.recommended-occupancy')}}</p>
							 			<p class="mb-1 text-15 font-medium body-2-2-1 lh-25">{{$t('hotel.adults.adult')}}: {{data.max_adults}} {{$t('hotel.room-type.guests')}}</p>
							 			<p class="mb-1 text-15 font-medium body-2-2-1 lh-25">{{$t('hotel.children.children')}}: {{data.max_children}} {{$t('hotel.room-type.guests')}}</p>
							 			<p class="mb-0 text-15 font-medium body-2-2-1 lh-25">{{$t('hotel.infants.infants')}}: {{data.max_infant}} {{$t('hotel.room-type.guest')}}</p>
							 		</div>
						 			<div class="pt-4">
	        					<div class="d-inline-block">
											<router-link :to="'/'+getMerchant.code+'/hotel-direct-detail/room_type/room_type/'+data.id+''">
			  	      				<button type="button" class="ga-btn-primary-md ga-btn-primary py-12px px-5 w-auto">{{$t('hotel.action.book-now')}}</button>
			  	      			</router-link>
	        					</div>
	        				</div>
						 		</div>
				 			</div>
				 		</div>
			 		</div>
			 	</div>		
			</div>
		 </div>
		 <div class="pb-5 mb-5"></div>
	 	<!-- FOOTER -->
		<Footer></Footer>

	</div>
</template>
<script>
	import {mapGetters,mapMutations} from 'vuex';
  import PopUpBackground from '@/components/hotel/be/PopUpBackgroundDesktop.vue';
  import Flickity from 'vue-flickity';
  import Header from '@/components/hotel/HeaderBE.vue';
  import Footer from '@/components/hotel/Footer.vue';
  import moment from 'moment';
	import {get} from '@/services/index.js'
  import {formatCurrency,formatDate} from '@/utils/index.js'
  import HomeNavbarDesktop from '@/components/hotel/be/desktop/HomeNavbar'
	import HomeNavbarMobile from '@/components/hotel/be/mobile/HomeNavbar'

	export default{
		components:{
			Flickity,
			Header,
			Footer,
			HomeNavbarDesktop,
			HomeNavbarMobile
		},
		data(){
			return{
				is_load: true,
				responsive: {
					mobile_header: false,
				},
				freeScrollSlider: {
          initialIndex: 0,
          autoPlay: 4000,
          prevNextButtons: false,
          pageDots: false,
          adaptiveHeight: true,
          draggable: false,
          wrapAround: false,
          contain: false,
          cellAlign: 'left',
          groupCells: false
        },
        room_type:"",
        max_guest: this.$defaultFilterBE('adult'),
				date:{
					check_in: moment().toDate(),
					check_out: moment(moment().toDate()).add(this.$defaultFilterBE('night'),'d').toDate()
				},
				image_undefine: 'https://guestapps.s3-ap-southeast-1.amazonaws.com/noimage.png'
			}
		},
		mounted(){
			document.getElementById('room-type').scrollIntoView({
        behavior: 'smooth'
      });
      this.loadRoomType()
		},
		computed:{
			...mapGetters(['getMerchant','getCurrentUser','isNotLogin','getRoomStay'])
		},
		methods:{
			loadRoomType(){
				this.is_load = true
				return new Promise((success,fail)=>{
					get("CORE_HOTEL",`room-type-list?adult=${this.max_guest}&child=0&infant=0&merchant_id=${this.getMerchant.id}&check_in_date=${this.formatTime(this.date.check_in)}&check_out_date=${this.formatTime(this.date.check_out)}&use_promotion_combine=true`).then(response=>{
						if (response.data.success) {
							this.room_type = response.data.data
							success()
						}else{
							fail(response.data.message)
						}
						this.is_load = false
					})
				})
			},
			formatTime(date){
				let format = "YYYY-MM-DD"
        return moment(date).format(format)
      },
      formatCurrency(data) {
        return formatCurrency(data)
      },
			callClick(){
				this.$emit('callClick')
			},
			detailRoomType(id){
				this.$router.push(`/${this.getMerchant.code}/room-type/${id}`)
			},
			headerMobile(){
				this.responsive.mobile_header = !this.responsive.mobile_header
			},
			shareClick(){
        this.$emit("shareClick")
      },
		}
	}
</script>


// WEBPACK FOOTER //
// src/pages/hotel/RoomType.vue